export default __webpack_public_path__ + "static/media/00_VideoPortfolio.c5185460.mp4";